/**
 * @generated SignedSource<<e711fe99884e965a8947360643fa4d6a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type requestType_nativeIssueTable_RequestTypeCell$data = {
  readonly requestType: {
    readonly avatar: {
      readonly xsmall: string | null | undefined;
    } | null | undefined;
    readonly name: string | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "requestType_nativeIssueTable_RequestTypeCell";
};
export type requestType_nativeIssueTable_RequestTypeCell$key = {
  readonly " $data"?: requestType_nativeIssueTable_RequestTypeCell$data;
  readonly " $fragmentSpreads": FragmentRefs<"requestType_nativeIssueTable_RequestTypeCell">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "requestType_nativeIssueTable_RequestTypeCell",
  "selections": [
    {
      "concreteType": "JiraServiceManagementRequestType",
      "kind": "LinkedField",
      "name": "requestType",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "name"
        },
        {
          "concreteType": "JiraAvatar",
          "kind": "LinkedField",
          "name": "avatar",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "xsmall"
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraServiceManagementRequestTypeField"
};

(node as any).hash = "e6355f63f017fb970ee2b3c6b04144d9";

export default node;
